import React from 'react';
import { NavLink } from "react-router-dom";

const Navbar = () => {
  return (
    <div className="navigation-body">
      <div>
        <NavLink className="navigation-item" to="/home/about">About</NavLink>
        <NavLink className="navigation-item" to="/home/resume">Resume</NavLink>
        <NavLink className="navigation-item" to="/home/skills">Skills</NavLink>
      </div>
    </div>
  );
};

export default Navbar;
